import React, {useEffect, useState} from 'react'
import axiosInstance from './../../http/axios';

import Toast from '../../toast';

import { TextField, Button, Fab, IconButton } from '@mui/material';
import AddRounded from '@mui/icons-material/AddRounded';
import CloseRounded from '@mui/icons-material/CloseRounded';
import ArrowBackRounded from '@mui/icons-material/ArrowBackRounded';

import Header from './../header/Header';

import DropdownMenu from '../dropdown_menu/DropdownMenu';

const CreateRetailer = ()=>{

     const [isSending, setIsSending] = useState(false);
     const [files, setFiles] = useState([null]);
     const [data, setData] = useState({
          category: '',
          time: 30,
          price: 1,
          description: '\n\n\n\n\n'
     })
     const selectionItems = ["None"];


     const navigate = (a)=> {
          if(typeof a == 'string'){
               window.location.href = a;
          }
          else if(typeof a == 'number'){
               window.history.go(a);
          }
     };

     const onChange = (event)=>{
          const { value, name } = event.target;
          setData(pVal => {
               if(name != 'file'){
                    return {
                         ...pVal,
                         [name]: value
                    };
               }
               else{
                    return {
                         ...pVal,
                         file: event.target.files[0]
                    };
               }
          });
          console.log(data);
     }

     const validate = () => {
          if(!data.name){
               Toast.error("Please enter plan name");
               return false;
          }
          else if(!data.password){
               Toast.error("Please enter password");
               return false;
          }
          else if(!data.location){
               Toast.error("Please enter location");
               return false;
          }
          else if(!data.description){
               Toast.error("Please enter description");
               return false;
          }
          else if(!data.opens){
               Toast.error("Please enter opening and closeing time");
               return false;
          }
          else if(!data.contactNumber){
               Toast.error("Please enter contact number");
               return false;
          }
          else if(files.length == 0){
               Toast.error("Please add store images");
               return false;
          }
          return true;
     }

     const onSubmit = async ()=>{

          if(!validate()) return;

          setIsSending(true)
          try {
               const rBody = new FormData();
               Object.keys(data).forEach(key => rBody.append(key, data[key]));
               files.map((file, i)=> rBody.append(`file${i}`, file))
               const res = await axiosInstance.post("admin/create-retailer", rBody, 
                    {
                         headers: { "Content-Type": "multipart/form-data" }
                    }
               )
               Toast.success('Success');
               setIsSending(false);
               navigate('/admin-retailers')
          } catch (error) {
               console.log(error);
               setIsSending(false)
               Toast.error('Failed');
          }
     }

     useEffect(()=> {
          console.log(files)
     }, [files]);

     

     const onFileAdd = (file)=> {
          const fileList = [...files];
          fileList.unshift(file)
          setFiles([...fileList]);
     }

     const removeFile = (index)=> {
          const fileList = [...files];
          fileList.splice(index, 1);
          setFiles([...fileList]);
     }


     const ImageItem = ({value, index}) => {
          console.log(value);
          if(value == null){
               return (
                    <div className='col-4 d-flex align-items-center justify-content-center' style={{height: '100px', background: '#dbdbdb', marginTop: '10px', borderRadius: '10px'}}>
                              <label htmlFor="upload-photo" style={{marginTop: '10px'}}>
                                   <input name="file" onChange={e=>onFileAdd(e.target.files[0])} style={{ display: 'none' }} id="upload-photo" type="file" itemType='image/*' />
                                   <AddRounded style={{color: 'gray', height: '50px', width: '50px'}}/>
                              </label>
                    </div>
               );
          }
          else{
               return (
                    <div className='col-4 d-flex align-items-center justify-content-center' style={{height: '100px', background: '#dbdbdb', marginTop: '10px', borderRadius: '10px', marginRight: '10px'}}>
                         <img style={{height: '100%'}} src={URL.createObjectURL(value)}/>
                         <span onClick={()=>removeFile(index)} style={{position: 'absolute', right: "0", top: "0"}}>
                              <CloseRounded style={{color: 'red', height: '30px', width: '30px'}}/>
                         </span>
                    </div>
               );
          }
     }

     return(
          <>
               <Header/>
               <div className="d-flex justify-content-between">
                    <div style={{height: '80px'}} className='d-flex align-items-center'>
                         <IconButton onClick={()=>navigate(-1)}><ArrowBackRounded/></IconButton>
                         <h5  style={{marginLeft: '10px', height: '100%', marginTop: '5px'}} className='d-flex align-items-center'>Add Retailer</h5>
                    </div>
               </div>
               <div className="d-flex justify-content-center" style={{marginTop: '50px'}}>
                    <div className='notification_container d-flex align-items-center flex-column' style={{width: '700px'}}>
                         {/* <h2 className='text-center' style={{marginTop: '50px'}}>Banner</h2> */}
                         <TextField name='name' value={data.name} onChange={onChange} style={{width: '90%', marginTop: '20px', color: 'red'}} fullWidth label="Name" type="text" />
                         <TextField name='password' value={data.password} onChange={onChange} style={{width: '90%', marginTop: '20px', color: 'red'}} fullWidth label="Password" type="password" />
                         <TextField name='location' value={data.location} onChange={onChange} style={{width: '90%', marginTop: '20px', color: 'red'}} fullWidth label="Location" type="text" />
                         <TextField name='description' value={data.description} onChange={onChange} style={{width: '90%', marginTop: '20px', color: 'red'}} multiline fullWidth label="Description" type="text" />
                         <TextField name='opens' value={data.opens} onChange={onChange} style={{width: '90%', marginTop: '20px', color: 'red'}} fullWidth label="Opening & Closeing Time" type="text" />
                         <TextField name='contactNumber' value={data.contactNumber} onChange={onChange} style={{width: '90%', marginTop: '20px', color: 'red'}} fullWidth label="Contact Number" type="number" />
                         <TextField name='balance' value={data.balance} onChange={onChange} style={{width: '90%', marginTop: '20px', color: 'red'}} fullWidth label="Balance" type="number" />
                         <div className='row' style={{width: "90%", marginTop: '20px'}}>
                              {files.map((val, index) => <ImageItem value={val} index={index}/>)} 
                         </div>
                                                 

                         <button onClick={onSubmit} style={{width: '90%', margin: '20px 0', cursor: isSending ? "progress" : 'pointer'}} className="__btn">Add</button>
                    </div>
               </div>
          </>
     );
}

export default CreateRetailer;